import React from 'react';
import ReactDOM from 'react-dom/client';
import './presentation/index.css'; // CSS global (ajustado para presentation, onde está o CSS principal)
import App from './App'; // Importa o App root (o router)
import reportWebVitals from './presentation/reportWebVitals'; // Relatório de performance

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance...
reportWebVitals();